import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useNavigation } from 'react-router-dom';

import { useOauthRedirect } from '@/components/AuthModal/hooks';
import ModalContactPrivate from '@/components/ModalContactPrivate';
import ModalErrorUploadPdf from '@/components/ModalErrorUploadPdf';
import ModalUpgradePlan from '@/components/ModalUpgradePlan';
import PaymentBreakdownModal from '@/components/PaymentBreakdownModal';
import { useIsTablet, useMediaQuery, useShallowEqualSelector } from '@/hooks';
import { fetchUser } from '@/store/profile/thunks';

import CheckoutLayout from '../CheckoutLayout';
import NoIndexMeta from '../NoIndexMeta';
import Scroller from '../Scroller';
import { useIsLoadingCheckout, useLayout } from '../hooks';
import Header from './Header';
import Sidebar from './Sidebar';
import { Loader, Wrapper } from './components';

function PrivateLayout() {
	const mdDown = useMediaQuery('mdDown');
	const dispatch = useDispatch();
	const navigation = useNavigation();
	const isLoadingCheckout = useIsLoadingCheckout();
	const isTablet = useIsTablet();

	const showHeader = mdDown || isTablet;

	const { loggedIn, fetchUserCompleted, userReady } = useShallowEqualSelector(
		({ profile }) => ({
			loggedIn: profile.loggedIn,
			fetchUserCompleted: profile.fetchUser.completed,
			userReady: profile.userReady
		})
	);
	useLayout();
	useOauthRedirect();

	useEffect(() => {
		if (!fetchUserCompleted || !loggedIn) {
			dispatch(fetchUser());
		}
	}, []);

	if (fetchUserCompleted && !loggedIn) {
		return <Navigate to="/" />;
	}

	if (isLoadingCheckout) {
		return <CheckoutLayout />;
	}

	if (!fetchUserCompleted && (!loggedIn || !userReady)) {
		return (
			<>
				{showHeader && <Header />}
				<NoIndexMeta />
				<div className="flex">
					{!mdDown && !isTablet && <Sidebar />}
					<Wrapper fullWidth={isTablet}>
						<Loader />
					</Wrapper>
				</div>
			</>
		);
	}

	return (
		<>
			<Scroller />
			<NoIndexMeta />
			{showHeader && <Header />}
			<div className="flex">
				{!mdDown && !isTablet && <Sidebar />}
				<Wrapper>
					{navigation.state === 'loading' ? <Loader /> : <Outlet />}
				</Wrapper>
			</div>
			<ModalContactPrivate />
			<ModalErrorUploadPdf />
			<ModalUpgradePlan />
			<PaymentBreakdownModal />
		</>
	);
}

export default PrivateLayout;
